import Vue from 'vue'
import axios from 'axios'
import factory from '../factory'

const store = factory('Seminars')

store.actions.getParticipants = async (_, id) => {
  const response = await axios.get(`seminar/${id}/participants`)
  return response.data
}

store.actions.registerParticipants = async ({ commit }, { id, participants }) => {
  const response = await axios.post(`seminar/${id}/participants`, { participants })
  if (response.data.seminar) {
    commit('update', response.data.seminar)
    commit('setSingle', response.data.seminar)
  }
  return response.data
}

store.actions.updateParticipant = async ({ commit }, { id, payload }) => {
  const response = await axios.put(`seminar/participant/${id}`, { obj: payload, returnObj: true })
  return response.data
}

store.actions.removeParticipant = async ({ commit }, { seminarId, participantId }) => {
  const response = await axios.delete(`seminar/participant/${participantId}`)
  if (response.data.seminar) {
    commit('update', response.data.seminar)
    commit('setSingle', response.data.seminar)
  }
  return response.data
}

store.actions.getHistory = async (_, id) => {
  const response = await axios.get(`seminar/${id}/history`)
  return response.data
}

store.actions.uploadCertificate = async ({ commit }, { seminarId, certificateType, data }) => {
  const formData = new FormData()
  if (data.png) formData.append('png', data.png)
  if (data.imageFile) formData.append('file', data.imageFile)
  formData.append('type', certificateType)
  if (data.canvas_json) formData.append('canvas_json', JSON.stringify(data.canvas_json))
  if (data.text_zone) formData.append('text_zone', JSON.stringify(data.text_zone))
  const response = await axios.post(`seminar/${seminarId}/certificate/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

store.actions.getCertificates = async (_, seminarId) => {
  const response = await axios.get(`seminar/${seminarId}/certificates`)
  return response.data
}

store.actions.deleteCertificate = async ({ commit }, { seminarId, certificateType }) => {
  const response = await axios.post(`seminar/${seminarId}/certificate/delete`, { type: certificateType })
  if (response.data.seminar) {
    commit('update', response.data.seminar)
    commit('setSingle', response.data.seminar)
  }
  const certificatesResponse = await axios.get(`seminar/${seminarId}/certificates`)
  return certificatesResponse.data
}

store.actions.getDocumentTypes = async (_, seminarId) => {
  const response = await axios.get(`seminar/${seminarId}/document-types`)
  return response.data
}

store.actions.createDocumentType = async (_, { seminarId, name, imageFile }) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('file', imageFile)
  const response = await axios.post(`seminar/${seminarId}/document-types`, formData)
  return response.data
}

store.actions.updateDocumentTypeFields = async (_, { seminarId, typeId, fields }) => {
  const response = await axios.post(`seminar/${seminarId}/document-types/${typeId}/fields`, { fields })
  return response.data
}

store.actions.renameDocumentType = async (_, { seminarId, typeId, name }) => {
  const response = await axios.post(`seminar/${seminarId}/document-types/${typeId}/rename`, { name })
  return response.data
}

store.actions.replaceDocumentTypeImage = async (_, { seminarId, typeId, imageFile }) => {
  const formData = new FormData()
  formData.append('file', imageFile)
  const response = await axios.post(`seminar/${seminarId}/document-types/${typeId}/image`, formData)
  return response.data
}

store.actions.deleteDocumentType = async (_, { seminarId, typeId }) => {
  const response = await axios.post(`seminar/${seminarId}/document-types/${typeId}/delete`)
  return response.data
}

store.mutations.removeImage = (state, { seminar, id }) => {
  const newImages = (seminar.images || []).filter(i => i.id !== id)
  Vue.set(state.singles[seminar.id], 'images', newImages)
}

store.mutations.removeDocument = (state, { seminar, id }) => {
  const newDocuments = (seminar.documents || []).filter(d => d.id !== id)
  Vue.set(state.singles[seminar.id], 'documents', newDocuments)
}

store.mutations.removeClubDeduction = (state, { seminar, id }) => {
  const newClubDeductions = (seminar.clubDeductions || []).filter(d => d.id !== id)
  Vue.set(state.singles[seminar.id], 'clubDeductions', newClubDeductions)
}

store.mutations.addClubDeduction = (state, { seminar, deduction }) => {
  const newClubDeductions = [...(seminar.clubDeductions || []), deduction]
  Vue.set(state.singles[seminar.id], 'clubDeductions', newClubDeductions)
}

store.mutations.updateClubDeduction = (state, { seminar, deduction }) => {
  const newClubDeductions = (seminar.clubDeductions || []).map(d => d.id === deduction.id ? deduction : d)
  Vue.set(state.singles[seminar.id], 'clubDeductions', newClubDeductions)
}

export default store
